import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import xiameBank from '@/router/modules/xiameBank.js'
import industrialBank from '@/router/modules/industrialBank.js'
import minfengBank from '@/router/modules/minfengBank.js'
import postalBank from '@/router/modules/postalBank.js'
import citicBank from '@/router/modules/citicBank.js'
import scenario from '@/router/modules/scenario.js'
import activityCenter from '@/router/modules/activityCenter.js'
import icbcBank from '@/router/modules/icbcBank.js'
import mutipleDiscount from '@/router/modules/mutipleDiscount.js'

const router = createRouter({
  history: process.env.VUE_APP_ENV === 'local' ? createWebHashHistory() : createWebHistory(process.env.VUE_APP_ROUTER_BASE), // hash模式：createWebHashHistory，history模式：createWebHistory
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/404'
    },

    ...xiameBank,
    ...industrialBank,
    ...minfengBank,
    ...postalBank,
    ...citicBank,
    ...scenario,
    ...activityCenter,
    ...icbcBank,
    ...mutipleDiscount,

    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/system/Login.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/system/404.vue'),
      meta: {
        requiresAuth: false
      }
    },
    // 所有未定义路由，全部重定向到404页
    {
      path: '/:pathMatch(.*)',
      redirect: '/404'
    },
  ]
})

export default router